import { useEffect, useRef, useState } from "react";
import {
  CheckIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/20/solid";
import SelectMenu from "../SelectMenu";

export default function InlineSelectMenu({
  value,
  onCommit,
  saveStatus = "idle",
  disabled,
  ...props
}) {
  const [draftValue, setDraftValue] = useState(value);
  const latestValue = useRef(value);
  const valueKey = value?.value;
  latestValue.current = value;

  useEffect(() => setDraftValue(latestValue.current), [valueKey]);

  const statusLabel = {
    saving: "Saving",
    saved: "Saved",
    error: "Save failed",
  }[saveStatus];

  return (
    <div className="flex items-center gap-1">
      <div className="min-w-0 flex-1">
        <SelectMenu
          {...props}
          value={draftValue}
          disabled={disabled}
          handleInputChange={(event) => {
            const nextValue = event.target.value;
            setDraftValue(nextValue);
            onCommit(nextValue);
          }}
        />
      </div>
      {!disabled ? (
        <span
          className="inline-flex h-4 w-4 shrink-0 items-center justify-center"
          role={statusLabel ? "status" : undefined}
          aria-label={statusLabel}
          title={statusLabel}
        >
          {saveStatus === "saving" ? (
            <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-300 border-t-indigo-600" aria-hidden="true" />
          ) : null}
          {saveStatus === "saved" ? (
            <CheckIcon className="h-4 w-4 text-green-600" aria-hidden="true" />
          ) : null}
          {saveStatus === "error" ? (
            <ExclamationCircleIcon className="h-4 w-4 text-red-600" aria-hidden="true" />
          ) : null}
        </span>
      ) : null}
    </div>
  );
}
